import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema4/T4_paneles_s2a1.glb";
import { GUI } from "dat.gui";
// import gsap from "gsap";

export class Paneles_mostrador extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.5, -0.75, -1.42);
		this.rotation.set(-0.4317, -0.8989, -0.3339);
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Pantalla = gltf.scene.getObjectByName("Panel_pantalla", true);
			this.Teclado = gltf.scene.getObjectByName("Panel_teclado", true);
			this.Escaner = gltf.scene.getObjectByName("Panel_escaner", true);
			this.PinPad = gltf.scene.getObjectByName("Panel_pinPad", true);
			this.Cpu = gltf.scene.getObjectByName("Panel_cpu", true);

			this.Pantalla.position.set(-0.4, 0.9, 0)
			this.Teclado.position.set(0.3, -0.1, 0)
			this.Escaner.position.set(-0.7, 0.3, 0)
			this.PinPad.position.set(0.15, 0.3, 0)
			this.Cpu.position.set(-1.2, 0, 0)

			this.Pantalla.visible = false
			this.Teclado.visible = false
			this.Escaner.visible = false
			this.PinPad.visible = false
			this.Cpu.visible = false
		})
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Paneles");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	helpersChild() {
		console.log(this.Pantalla.position);
		console.log(this.Teclado);
		console.log(this.Escaner);
		console.log(this.PinPad);
		console.log(this.Cpu);
		this.helpersMethod("Pantalla", this.Pantalla);
		this.helpersMethod("Teclado", this.Teclado);
		this.helpersMethod("Escaner", this.Escaner);
		this.helpersMethod("PinPad", this.PinPad);
		this.helpersMethod("CPU", this.Cpu);
	}


	helpersMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

}